import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const retryAeoOnboardingStep = unaryRpc({
  name: "retryAeoOnboardingStep",
  input: z.object({
    teamId: zExt.objectId(),
    runId: z.string(),
    stepKey: z.string(),
  }),
  output: z.object({ status: z.string() }),
});
